export const getIsOldiPhone = () => {
  const model = getiPhoneModel();
  return model === iPHONE1_3 || model === iPHONE4_4S || model === iPHONE5_5C_5S;
};

// iPhone model checks.
// https://51degrees.com/blog/device-detection-for-apple-iphone-and-ipad
// https://analytical42.com/2017/detect-and-track-iphone-models-in-google-analytics/
export const getiPhoneModel = () => {
  if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
    const width = window.screen.width > window.screen.height ? window.screen.height : window.screen.width;
    const height = window.screen.width > window.screen.height ? window.screen.width : window.screen.height;
    const wh = width / height;
    const ratio = window.devicePixelRatio;

    if (wh == 320 / 480 && ratio == 1) {
      return iPHONE1_3;
    }

    if (wh == 640 / 960 && ratio == 2) {
      return iPHONE4_4S;
    }

    if (wh == 640 / 1136 && ratio == 2) {
      return iPHONE5_5C_5S;
    }

    if (wh == 750 / 1334 && ratio == 2) {
      return iPHONE6_6S_7_8;
    }

    if (wh == 640 / 1136 && ratio == 2) {
      return iPHONE6_6S_7_8_DZ;
    }

    if (wh == 1242 / 2208 && ratio == 3) {
      return iPHONE6_6S_7P_8P;
    }

    if (wh == 1125 / 2001 && ratio == 3) {
      return iPHONE6_6S_7P_8P_DZ;
    }

    if (wh == 375 / 812 && ratio == 3) {
      return iPHONEX;
    }
    return '';
  } else {
    return '';
  }
};

const iPHONE1_3 = 'iPhone 1/3g/3gs';
const iPHONE4_4S = 'iPhone 4/4s';
const iPHONE5_5C_5S = 'iPhone 5/5c/5s';
const iPHONE6_6S_7_8 = 'iPhone 6/6s/7/8';
const iPHONE6_6S_7_8_DZ = 'iPhone 6/6s/7/8 (Display Zoom)';
const iPHONE6_6S_7P_8P = 'iPhone 6/6s/7 Plus/8 Plus';
const iPHONE6_6S_7P_8P_DZ = 'iPhone 6/6s/7 Plus/8 Plus (Display Zoom)';
const iPHONEX = 'iPhone X';
